import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import SecureLS from 'secure-ls'

import user from '@/store/modules/user'
import loading from '@/store/modules/loading'
import orders from '@/store/modules/orders'
import modal from '@/store/modules/modal'
import filters from '@/store/modules/filters'
import messages from '@/store/modules/messages'

const ls = new SecureLS({ isCompression: false })

const vuexLocal = new VuexPersistence({
  key: `movimenta-partner-${process.env.NODE_ENV}`,
  storage: window.localStorage,
  saveState: (key, state) => ls.set(key, state),
  restoreState: key => ls.get(key)
})

Vue.use(Vuex)

const store = new Vuex.Store({
  plugins: [ vuexLocal.plugin ],
  modules: {
    namespaced: true,
    user,
    loading,
    orders,
    modal,
    filters,
    messages
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js